import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: auto;
  padding: 0px;
  gap: 10px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const CheckRow = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
  grid-template-columns: 3fr repeat(3, 1fr);
  margin-bottom: 0px;
  background-color: ${({ index }) => index % 2 === 0 ? '#EEEEEE' : '#F7F7F7'};
  padding: 0px 5px;
  gap: 3px;

  label {
    margin-bottom: 1px;
    justify-self: flex-start;
    padding-left: ${({ isChild }) => isChild ? 25 : 10}px;
  }

  h3 { margin-bottom: 3px; }
  button { margin: 0px; }
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  margin-bottom: 15px;
  padding: 0px;
`

export const PermissionsContainer = styled(FormField)`
  margin: 0px 5px 10px;
  border: 1px solid #EEEEEE;
  border-radius: 8px;
  overflow: hidden;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const SmallButton = styled(LookButton).attrs({ type: 'button' }).attrs(buttonLook({ variant: 'ghost' }))`
  gap: 7px;
  align-self: center;
  margin-bottom: 15px;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`

export const SubTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 15px;
  align-self: center;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 5px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin-bottom: 4px;

  &:hover {
    cursor: pointer;
  }
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-top: 15px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`
